import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { showErrorToast } from '../../utils/toast';
import { formatDate } from '../../utils/helper';

const initialState = {
  pendingLoans: [], // Changed from loans to pendingLoans to match the state name
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPrevPage: false
  },
  loading: false,
  error: null,
  filters: {
    search: '',
    page: 1,
    limit: 10,
    type: '',
    sortBy: 'createdAt',
    sortOrder: 'desc',
    startDate: null,
    endDate: null,
  },
};

export const fetchPendingLoans = createAsyncThunk(
  'loans/fetchLoans',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { filters } = getState().loans;
      console.log(filters)
      const queryParams = new URLSearchParams({
        page: filters.page,
        limit: filters.limit,
        search: filters.search,
      });
      
      if (filters.type && filters.type !== '') {
        queryParams.set('type', filters.type);
      }
      if (filters.startDate && filters.endDate) {
        queryParams.set('startDate', formatDate(filters.startDate))
        queryParams.set('endDate', formatDate(filters.endDate))
      }

      const response = await axiosInstance.get(`/loan/pendingLoans?${queryParams}`);
      console.log(response.data.data);
      return response.data.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch loans';
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const pendingLoansSlice = createSlice({
  name: 'loans',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      if (action.payload.search || action.payload.status) {
        state.filters.page = 1;
      }
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingLoans = action.payload.loans || []; // Changed from loans to pendingLoans
        state.pagination = action.payload.pagination || initialState.pagination;
      })
      .addCase(fetchPendingLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilter, resetFilters } = pendingLoansSlice.actions;
export default pendingLoansSlice.reducer;